namespace Areas {
    "use strict";

    export interface IDictionary {
        [index: string]: string;
    }

    export function updateQueryStringParameter(uri: any, key: any, value: any) {
        const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i");
        const separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, `$1${key}=${value}$2`);
        } else {
            return uri + separator + key + "=" + value;
        }
    }

    export function removeQueryStringParameter(url: string, parameter: string) {
        //prefer to use l.search if you have a location/link object
        const urlparts = url.split("?");
        if (urlparts.length >= 2) {

            const prefix = encodeURIComponent(parameter) + "=";
            const pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + (pars.length > 0 ? `?${pars.join("&")}` : "");
            return url;
        } else {
            return url;
        }
    }

    export function isNotEmpty(variable: any) {
        return variable !== undefined && variable != null && variable !== "";
    }

    export function isEmpty(variable: any) {
        return !isNotEmpty(variable);
    }

    export function trimTextBoxValue(e: any) {
        var textBox = e.component as DevExpress.ui.dxTextBox;
        textBox.option("value", $.trim(e.value));
    }

    export function partition(items, n) {
        var result = _.groupBy(items, function(item, i) {
            return Math.floor(i % n);
        });
        return _.values(result);
    }

    export function clone(object: any) {
        const json = JSON.stringify(object);
        return JSON.parse(json);
    }  
    
    export function elementIdExists(elementId: string) : boolean {
        return Boolean($(`#${elementId}`).length);
    }



    export function goToEdit() {
        location.href = location.href.replace("/View", "/Edit");
    } 

    export function goToView() {
        location.href = location.href.replace("/Edit", "/View");
    } 

    export function reloadPage() {
        location.href = location.href;
    } 

    export function onContentReadySelectFirstRow(e: any) {
        e.component.selectRowsByIndexes([0], false);
    }

    export function onGridSelectionChanged(e: any) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            enableButton("EditButton");
        } else {
            disableButton("EditButton");
        }
    }

    export function clearSelectBoxSelection(e: any) {
        const selectBox = e.component as DevExpress.ui.dxSelectBox;
        selectBox.reset();
    }    

    export function formatDateTime(date: Date): string {
        return formatDate(date) + " " + formatTime(date);
    }

    function formatDate(date: Date): string {
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();

        const day = ("0" + date.getDate()).slice(-2);

        const formattedDate = `${month}/${day}/${year}`;
        return formattedDate;
    }

    function formatTime(date: Date): string {
        let hours = date.getHours();
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        const minutes = ("0" + date.getMinutes()).slice(-2);
        const formattedTime = hours + ":" + minutes + " " + ampm;
        return formattedTime;
    }    

}